module.exports = __webpack_public_path__ + "static/img/samajuri (22).ca73fc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (22).jpg
// module id = M113
// module chunks = 0